<template>
    <!-- NOT CURRENTLY IN USE -->
    <div class="dashboard-layout">
        <div class="header relative z-10 bg-dashGrey-light shadow-md p-4">
            <headerVue></headerVue>
        </div>
       
        <div class="page bg-dashGrey-light p-2 h-full">
            <!-- <NuxtPage></NuxtPage> -->
            <slot />
        </div>
        <div class="navigation relative z-20 bg-dashGrey-light h-full">
            <navigation></navigation>
            <SideNavigation></SideNavigation>
        </div>
    </div>
</template>
<script setup>

const navStatus = useState('isNavOpen', () => true)

definePageMeta({
    middleware: ['auth']
})



const toggleNavigation = () => {
    navStatus.value = !navStatus.value;
}

</script>
<style lang="scss">

.dashboard-layout{
    transition: all .5s ease;
    height: 100%;
    display: grid; 
    //grid-template-columns: minmax(0%,auto) 1fr;
    grid-template-columns: auto 1fr;
    //grid-template-rows: minmax(25px, auto) 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas:
    "gridNav gridHeader"
    "gridNav gridPage";
    

    .header{
        grid-area: gridHeader;
    }
    .page{
        grid-area: gridPage;
    }
  .navigation{
        grid-area: gridNav; 
    } 
}


</style>